// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11qXN","comment":"styles_comment__3DGrx"};